import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const addArtifactForDeal = (treeId, dealId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'ADDING_ARTIFACT_FOR_DEAL' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/discovery-tree/${treeId}/deals/${dealId}`,
            payload,
            {
              params: {
                requestId: reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'ADDING_ARTIFACT_FOR_DEAL_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'ADDING_ARTIFACT_FOR_DEAL_FAILED',
              payload: `Failed to add activity for deal`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'ADDING_ARTIFACT_FOR_DEAL_FAILED',
            payload: `Failed to add activity for deal`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'ADDING_ARTIFACT_FOR_DEAL_FAILED',
        payload: `Failed to add activity for deal`,
      });
    }
  };
};

export default addArtifactForDeal;
